import { JureCdc } from './jure-cdc.model';

export class JureSynthese extends JureCdc {
    static jsonMap = {
        ...JureCdc.jsonMap,
        nbConvocation: 'nbConvocation',
        nbPresent: 'nbPresent',
        nbExcuse: 'nbExcuse',
        nbAbsent: 'nbAbsent',
        nbDesinscrit: 'nbDesinscrit',
        nbConvoque: 'nbConvoque',
        nbAConvoque: 'nbAConvoque',
        nomSalle: { key: 'nomSalle', optional: true, default: '' },
        adresseSalle: { key: 'adresseSalle', optional: true, default: '' },
        villeSalle: { key: 'villeSalle', optional: true, default: '' },
        libelleCollege: { key: 'libelleCollege', optional: true, default: '' },
        cahierDesCharges: { key: 'cahierDesCharges', default: () => [] },
        adresseJure: { key: 'adresseJure', optional: true, default: '' },
        complementAdresseJure: { key: 'complementAdresseJure', optional: true, default: '' },
        codePostalJure: { key: 'codePostalJure', optional: true, default: '' },
        villeJure: { key: 'villeJure', optional: true, default: '' }
    };

    nbConvocation: number;
    nbPresent: number;
    nbExcuse: number;
    nbAbsent: number;
    nbDesinscrit: number;
    nbConvoque: number;
    nbAConvoque: number;
    nomSalle: string;
    adresseSalle: string;
    villeSalle: string;
    libelleCollege: string;
    cahierDesCharges: string[];
    adresseJure: string;
    complementAdresseJure: string;
    codePostalJure: string;
    villeJure: string;
}
